import React, { Fragment, useState, useEffect } from 'react'
import { Modal, Typography } from '@material-ui/core'
import { toast } from 'sonner'
import globalStyles from '../style.module.css'
import { useRegistrationCertificatesStore } from '../stores/registrationCertificateStore'
import Button from '../../../generic/Button'

export const ManualDateInputModal = ({ onSubmit }) => {
	const {
		manualDateInputModalOpen,
		setManualDateInputModalOpen,
		certificatesNeedingDates,
		setCertificatesNeedingDates,
	} = useRegistrationCertificatesStore()

	const [manualDates, setManualDates] = useState({})
	const [submitting, setSubmitting] = useState(false)

	useEffect(() => {
		// Initialize manual dates state when modal opens
		if (manualDateInputModalOpen && certificatesNeedingDates.length > 0) {
			const initialDates = {}
			certificatesNeedingDates.forEach((cert) => {
				initialDates[cert.registrationCertificateNumber] = ''
			})
			setManualDates(initialDates)
		}
	}, [manualDateInputModalOpen, certificatesNeedingDates])

	const handleClose = () => {
		setManualDates({})
		setCertificatesNeedingDates([])
		setManualDateInputModalOpen(false)
		setSubmitting(false)
	}

	const handleDateChange = (certNumber, value) => {
		setManualDates({
			...manualDates,
			[certNumber]: value,
		})
	}

	const handleSubmit = async () => {
		// Validate all dates are filled
		for (const cert of certificatesNeedingDates) {
			const date = manualDates[cert.registrationCertificateNumber]
			if (!date || date.trim() === '') {
				toast.error(
					`Please provide a date for certificate ${cert.registrationCertificateNumber}`,
				)
				return
			}

			// Validate date format
			const parsedDate = new Date(date)
			if (isNaN(parsedDate.getTime())) {
				toast.error(
					`Invalid date format for certificate ${cert.registrationCertificateNumber}`,
				)
				return
			}
		}

		setSubmitting(true)

		try {
			await onSubmit(manualDates)
			handleClose()
		} catch (error) {
			console.error('Error submitting manual dates:', error)
			toast.error('Failed to submit dates. Please try again.')
			setSubmitting(false)
		}
	}

	const allDatesFilled = certificatesNeedingDates.every(
		(cert) =>
			manualDates[cert.registrationCertificateNumber] &&
			manualDates[cert.registrationCertificateNumber].trim() !== '',
	)

	return (
		<Fragment>
			<Modal open={manualDateInputModalOpen} onClose={handleClose}>
				<div
					style={{
						backgroundColor: 'white',
						padding: '20px',
						width: '60vw',
						maxHeight: '80vh',
						overflow: 'auto',
						margin: 'auto',
						marginTop: '10vh',
					}}
				>
					<h3>Manual Date Input Required</h3>
					<br />
					<Typography variant='body2'>
						The following certificates could not be found in the USCO database.
						Please manually enter their effective registration dates.
					</Typography>
					<br />

					<div style={{ maxHeight: '400px', overflow: 'auto' }}>
						{certificatesNeedingDates.map((cert, index) => (
							<div
								key={index}
								style={{
									marginBottom: '20px',
									padding: '15px',
									border: '1px solid #ddd',
									borderRadius: '4px',
								}}
							>
								<Typography variant='body2' style={{ fontWeight: 'bold' }}>
									{cert.registrationCertificateNumber}
								</Typography>
								<Typography
									variant='body2'
									style={{ color: 'rgb(142, 147, 155)', marginTop: '5px' }}
								>
									{cert.partnerImageIds.length} image(s) associated
								</Typography>
								<Typography
									variant='body2'
									style={{ marginTop: '10px', marginBottom: '5px' }}
								>
									Effective Registration Date (YYYY-MM-DD)
								</Typography>
								<input
									type='date'
									className={globalStyles.searchInput}
									value={manualDates[cert.registrationCertificateNumber] || ''}
									onChange={(e) =>
										handleDateChange(cert.registrationCertificateNumber, e.target.value)
									}
									style={{ width: '100%' }}
								/>
							</div>
						))}
					</div>

					<div style={{ display: 'flex', marginTop: '20px', gap: '10px' }}>
						<Button onClick={handleClose} disabled={submitting}>
							Cancel
						</Button>
						<Button
							onClick={handleSubmit}
							disabled={!allDatesFilled || submitting}
						>
							{submitting ? 'Submitting...' : 'Submit All'}
						</Button>
					</div>
				</div>
			</Modal>
		</Fragment>
	)
}
